import {NgModule} from '@angular/core';
import {AngularEpubViewerComponent} from './angularEpubViewer.component';

@NgModule({
  imports: [],
  declarations: [AngularEpubViewerComponent],
  exports: [AngularEpubViewerComponent]
})
export class AngularEpubViewerModule {}
